import styles from './ui.module.css'

// Confidence, status, HTTP method and op-id badges (§3.5, §5.7).

export function ConfidenceBadge({ level }) {
  const known = level === 'proven' || level === 'documented' || level === 'confirm'
  if (!known) return null
  return (
    <span className={`${styles.badge} ${styles[level]}`}>
      <span className={`${styles.dot} ${styles[`dot_${level}`]}`} aria-hidden="true" />
      {level}
    </span>
  )
}

const STATUS_CLASS = {
  Ready: 'statusReady',
  approved: 'statusReady',
  implemented: 'statusReady',
  Draft: 'statusDraft',
  open: 'statusOpen',
  rejected: 'statusOpen',
}

export function StatusBadge({ status }) {
  if (!status) return null
  return <span className={`${styles.statusBadge} ${styles[STATUS_CLASS[status] ?? 'statusOpen']}`}>{status}</span>
}

export function SystemStatusBadge({ status }) {
  if (status === 'ready') return <StatusBadge status="Ready" />
  if (status === 'draft') return <StatusBadge status="Draft" />
  return null
}

const METHOD_SIZES = {
  main: { fontSize: 11.5, padding: '3px 7px', letterSpacing: '0.03em' },
  secondary: { fontSize: 11, padding: '3px 6px', letterSpacing: '0.03em' },
  step: { fontSize: 10.5, padding: '2px 6px' },
}

export function MethodBadge({ method, size = 'main' }) {
  const upper = String(method ?? '').toUpperCase()
  const tone = upper === 'GET' ? styles.methodGet : upper === 'PUT' || upper === 'PATCH' ? styles.methodPut : upper === 'DELETE' ? styles.methodDelete : styles.methodPost
  return (
    <span className={`${styles.method} ${tone}`} style={METHOD_SIZES[size] ?? METHOD_SIZES.main}>
      {upper}
    </span>
  )
}

export function OpTag({ children, compact = false }) {
  return (
    <span className="op-tag" style={compact ? { padding: '2px 7px' } : undefined}>
      {children}
    </span>
  )
}
